import classes from './Start.module.css';

const Start = () => {
  return (
    <aside className={classes.startContainer}>
      <p className={classes.title}>Arranca en minutos...</p>
      <p className={classes.principalText}>
        Ofrece una experiencia instruccional atractiva e intuitiva a
        tus estudiantes.
      </p>
      <div className={classes.startBox}>
        <p className={classes.startNumber}>1</p>
        <p className={classes.startTitle}>Crea y personaliza</p>
        <p className={classes.startText}>
          Comienza por crear tu Academia. En ella podrás habilitar
          tus cursos.
        </p>
      </div>
      <div className={classes.startBox}>
        <p className={classes.startNumber}>2</p>
        <p className={classes.startTitle}>Habilita contenidos</p>
        <p className={classes.startText}>
          Crea tus cursos y elige si quieres venderlos en tu
          Academia, en la EduStore, o en ambas.
        </p>
      </div>
      <div className={classes.startBox}>
        <p className={classes.startNumber}>3</p>
        <p className={classes.startTitle}>¡Disfruta tus ventas!</p>
        <p className={classes.startText}>
          Recibe visitas y observa cómo se concretan las ventas de
          tus cursos.
        </p>
      </div>
    </aside>
  );
};

export default Start;
